export default {
  valuationTitle: 'Sugerencias de evaluación del recurso',
  downloadableContent: 'Contenido descargable',
  evaluationMethod: 'Tipo de evaluación'
}

export const en = {
  valuationTitle: 'Suggested resource evaluation',
  downloadableContent: 'Downloadable content',
  evaluationMethod: 'Evaluation Type'
}

export const ca = {
  valuationTitle: 'Suggeriments d\'avaluació del recurs',
  downloadableContent: 'Contingut descarregable',
  evaluationMethod: 'Tipus d\'avaluació'
}
